import {useQuery, UseQueryResult, useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {fundraisersApi} from '../api';
import {FundraiserStoryDetailedModel, UpdateFundraiserStoryDTO} from '../model';
import {useNotifications} from '../../../shared';

type UseFundraiserStoryByIdResult = {
  getStory: UseQueryResult<FundraiserStoryDetailedModel, Error>;
  refetchStory: () => void;
  updateStoryMutation: UseMutationResult<any, Error, UpdateFundraiserStoryDTO>;
};

export const useFundraiserStoryById = (appealId: string, storyId: string): UseFundraiserStoryByIdResult => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const getStory = useQuery({
    queryKey: ['fundraiser-story', appealId, storyId],
    queryFn: () => fundraisersApi.getFundraiserStoryDetailedById(appealId, storyId),
    enabled: Boolean(appealId && storyId),
  });

  const updateStoryMutation = useMutation({
    mutationFn: (dto: UpdateFundraiserStoryDTO) => fundraisersApi.updateFundraiserStory(appealId, storyId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['fundraiser-story', appealId, storyId]});
      queryClient.invalidateQueries({queryKey: ['fundraiser-stories', 'infinite']});
      createNotification({
        title: 'История сбора успешно обновлена',
        name: 'updateFundraiserStory',
        theme: 'success',
      });
    },
  });

  const refetchStory = () => {
    getStory.refetch();
  };

  return {
    getStory,
    refetchStory,
    updateStoryMutation,
  };
};
